<template>
  <div class="data-resort">
    <!-- <template #left>
        <n-tag
          class="tag"
          :color="{
            color: '#EEEAFE',
            borderColor: '#572DF3',
            textColor: '#572DF3',
          }"
        >
          {{ type }}
        </n-tag>
      </template> -->

    <!-- <n-card class="title-box" title="Set Filters first">
      <div>
        ConsumerType: Provided Datasets used by Use Cases or Datasets or Datasets with no usage (unused) <br />
        Dataset Hub: Hub of the provided Datasets <br />
        Dataset Status: Status of the provided Datasets
        <br />
        Dataset Layer: Layer of provided Datasets <br />
        Consumer Hub: Hub of the consumin Dataset/ Use Case (depends on filter setting for consumer type) <br />
        Cross DBO Usage: Show only Datasets that are used in the same ressort (false), or different ressorts (true)
      </div>
    </n-card> -->

    <!-- <div class="datasetAna_des">Data Model ID: {{ dataModelId }}</div> -->

    <!-- <DataModelView class="data-model-canvas"></DataModelView> -->

    <n-spin v-if="data" class="data-resort-loading" description="Loading" :show="loading">
      <PieChart
        class="data-piechart"
        title="Number of Dataset Connections per DBO as Provider"
        :count="data.count"
        :data="data.providerCircle"
        :color="COLOR_MAP"
      ></PieChart>

      <SankeyEcharts
        class="data-sankey"
        title="Number of Connections (=Usage) of Datasets of a DBO (Left Side) by Another DBO (Right Side)"
        :data="data.consumerStream"
        :color="COLOR_MAP"
      ></SankeyEcharts>

      <PieChart
        class="data-piechart"
        title="Number of Dataset Connections per DBO as Consumer"
        :count="data.count"
        :data="data.consumerCircle"
        :color="COLOR_MAP"
      ></PieChart>
    </n-spin>
  </div>
</template>

<script setup lang="ts">
import { h, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { NSpin, NCard } from 'naive-ui';

import HeadTitle from '@/components/HeadTitle.vue';
// import DataModelView from '@/components/DataModelView/index.vue';
import DataResort from '@/components/SankeyGraph/index.vue';
import SankeyEcharts from '@/components/SankeyGraph/SankeyEcharts.vue';
import PieChart from '@/components/PieChart/index.vue';
import { getDataResort } from '@/api/dataResort';

import rawData from './mock.ts';
const route = useRoute();

const data = ref<any>(null);

const dataModelId = ref<any>('');

dataModelId.value = route.query.id;

const COLOR_MAP = [
  '#170E67',
  '#5717AC',
  '#572DF3',
  '#FFA201',
  '#C623F9',
  '#4122B3',
  '#9378F4',
  '#7B1FDB',
  '#FF18B4',
  '#FFD70D',
  '#1F29DB',
  '#800B5B',
  '#704EE9',
  '#2367F9',
  '#FF63CE',
  '#acdd8b',
  '#b0bbe9',
];

const loading = ref<boolean>(false);

const layoutEndHandler = () => {
  loading.value = false;
};

onMounted(() => {
  getDataResort().then((res: any) => {
    // const { nodes, relations } = res || {};
    data.value = res;
  });
  // data.value = rawData;
});
</script>

<style lang="scss" scoped>
@import '@/styles/common_details.scss';
.data-resort {
  height: 100%;
  width: 100%;

  .tag {
    margin-left: 15px;
  }

  .data-piechart {
    min-width: 20%;
  }

  .data-sankey {
    width: calc(60% - 40px);
  }
}
</style>

<style lang="scss">
.data-resort {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-image: url('@/assets/edm_bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 20px;
  .title-box {
    text-align: center;
    .n-card-header__main {
      font-weight: 700;
      font-size: 18px;
    }

    .n-card__content {
      font-size: 14px;
    }
  }

  .data-resort-loading {
    height: calc(100% - 63px);
    overflow: hidden;
    .n-spin-content {
      height: 100%;
      display: flex;
      column-gap: 20px;
      overflow: hidden;

      > * {
        border-radius: 5px;
      }
    }
  }
}
</style>
